import { createFileRoute } from '@tanstack/react-router';
import { SourcesList } from '@/features/sources/components/SourcesList/SourcesList';
import { Card, CardContent } from '@/shared/components/ui/Card';

export const Route = createFileRoute('/_auth/sources/')({
  component: SourcesIndexPage,
});

function SourcesIndexPage() {
  return (
    <div className="min-h-screen bg-gray-50 py-8">
      <div className="container mx-auto px-4">
        <Card className="col-span-12 lg:col-span-9">
          <CardContent className="p-6">
              <SourcesList />
            </CardContent>
        </Card>      
      </div>
    </div>
 );
}
